import { useCallback, useEffect, useRef, useState } from "react"
import { ErrorCard, LoadingCard, MainContainer, VirtualizeAutoComplete } from "../../components"
import { ENUM_INVOICE_TYPE } from "../creditdebitnote/enum"
import { Button, Autocomplete, AutocompleteItem, Checkbox, Input, Select, SelectItem } from "@nextui-org/react"
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers"
import dayjs from "dayjs"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { apiRoute, ENUM_INPUT_TYPE, ENUM_MOD_NAME, ENUM_MOD_PARAMETER, funValidateNoInput, getModMandatory, getModValue, getModVisiblity, linksUrl } from "../../constants/enum"
import { isMobile } from "react-device-detect"
import { useFetchWithBody, usePost } from "../../api/reactQueryCustomHooks"
import { useSelector } from "react-redux"
import { faCancel, faPlus, faSave, faSquareXmark, faTrashCan } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { toast } from "react-toastify"
import { useNavigate } from "react-router-dom"
import { funValidateYear } from "../../Utility/utility"


const CreateMonthExpEntry = () => {
    const { compCode, isMultipleCompany } = useSelector((state) => state.company)
    const { isNewEntry, detailParams } = useSelector((state) => state.monthExpEntry)
    const { user } = useSelector((state) => state.auth);
    const navigate = useNavigate();


    const { isLoading, data: masterData = [] } = useFetchWithBody({
        url: apiRoute.monthExpense.fetchMasterData,
        queryKey: "getMasterData",
        inputData: {
            comp_code: compCode.join(",")
        }
    })

    console.log(isNewEntry)
    const ENUM_EXPENSE_TYPE = [
        {
            key: "", value: "FIXED"
        },
        {
            key: "PRD", value: "PRODUCTION"
        }
    ]
    const ENUM_MONTH = [
        { value: "January", key: "01" },
        { value: "February", key: "02" },
        { value: "March", key: "03" },
        { value: "April", key: "04" },
        { value: "May", key: "05" },
        { value: "June", key: "06" },
        { value: "July", key: "07" },
        { value: "August", key: "08" },
        { value: "September", key: "09" },
        { value: "October", key: "10" },
        { value: "November", key: "11" },
        { value: "December", key: "12" },
    ]

    const onSuccessTasks = (data) => {
        // navigate(linksUrl.monthExpense.monthExpEntryMaster);
        window.location.reload();

    }
    const { isError, isPending, mutate: funAddUpdate } = usePost({
        url: apiRoute.monthExpense.add_update,
        queryKey: "funAddUpdateJournalVoucher",
        onSuccessTasks
    })

    const { isError: isErrorDetail, data: detail = [], mutate: funGetDetail } = usePost({
        url: apiRoute.monthExpense.fetchEntry,
        queryKey: "fetchMonthExpDetail",
    });

    useEffect(() => {
        if (isMultipleCompany)
            navigate(linksUrl.dashboard.tradingDashboard)


        if (!isNewEntry && detailParams && Object.keys(detailParams).length > 0) {
            const { comp_code, detail_id } = detailParams
            funGetDetail({
                data: {
                    comp_code: comp_code,
                    detail_id: detail_id
                }
            })
        }
    }, [])


    const formField = {
        detailId: "detailId",
        year: "year",
        month: "month",
        unitId: "unitId",
        acId: "acId",
        amount: "amount",
        expType: "expType",

    }
    
    const emptyFormField = Object.keys(formField).reduce((acc, key) => {
        if (key == formField.amount || key == formField.detailId)
            acc[key] = 0
        else acc[key] = ""
        return acc
    }, {})


    const [formData, setFormData] = useState({
        ...emptyFormField
    })

    const inputBoxes = {
        Row1: [
            {
                id: formField.year,
                name: formField.year,
                placeholder: "Year.",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: true,
            },

            {
                id: formField.month,
                name: formField.month,
                placeholder: "Month",
                type: ENUM_INPUT_TYPE.autocomplete,
                size: "sm",
                label: "",
                data: ENUM_MONTH,
                itemkey: "key",
                itemvalue: "value",
                isrequired: true,
            }
        ],

        Row2: [{
            id: formField.unitId,
            name: formField.unitId,
            placeholder: "Unit Name",
            type: ENUM_INPUT_TYPE.autocomplete,
            size: "sm",
            label: "",
            data: masterData && masterData?.unitMaster ? masterData.unitMaster || [] : [],
            itemkey: "Party_Id",
            itemvalue: "Party_Name",
            isrequired: true,
        },
        {
            id: formField.acId,
            name: formField.acId,
            placeholder: "Exp Name",
            type: ENUM_INPUT_TYPE.autocomplete,
            size: "sm",
            label: "",
            data: masterData && masterData?.acMaster ? masterData.acMaster || [] : [],
            itemkey: "Party_Id",
            itemvalue: "Party_Name",
            isrequired: true,
        }
        ],
        Row3: [
            {
                id: formField.amount,
                name: formField.amount,
                placeholder: "Amount",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: true,
            },
            {
                id: formField.expType,
                name: formField.expType,
                placeholder: "Exp Type",
                type: ENUM_INPUT_TYPE.autocomplete,
                size: "sm",
                label: "",
                data: ENUM_EXPENSE_TYPE,
                itemkey: "key",
                itemvalue: "value",
                isrequired: false,
            },


        ],

    }

    const handleChange = (e) => {
        const { name, value } = e.target
        if (funValidateNoInput(value))
            setFormData({ ...formData, [name]: value })
    }

    const handleBlur = (e) => {
        const { name, value } = e.target
        if (name == formField.year && value!='') {
            const msg = funValidateYear(value)
            if (msg != "") {
                toast.error(msg, {
                    position: 'top-center',
                    className:"toast-error"
                })
                setFormData({ ...formData, [formField.year]: '' })
            }
        }
    }

    const handleAutoCompleteChange = (value, name) => {
        setFormData({
            ...formData,
            [name]: value,

        })


    }

    const [errors, setErrors] = useState({})

    const validateForm = () => {
        const newErrors = {}

        // Validate username
        if (formData.year.trim() == "") {
            newErrors[formField.year] = "Year  required"
        }
        if (formData[formField.month] == "" || formData[formField.month] == null || formData[formField.month] == "0") {
            newErrors[formField.month] = "Month  required"
        }
        if (formData[formField.unitId] == "" || formData[formField.unitId] == null || formData[formField.unitId] == "0") {
            newErrors[formField.unitId] = "Unit  required"
        }

        if (formData[formField.acId] == "" || formData[formField.acId] == null || formData[formField.acId] == "0") {
            newErrors[formField.acId] = "Exp. Name  required"
        }
        if (formData[formField.amount] == "" || formData[formField.amount] == "0") {
            newErrors[formField.amount] = "Amount required"
        }

        setErrors(newErrors)

        // Return true if there are no errors
        return Object.keys(newErrors).length === 0
    }

    useEffect(() => {
        validateForm();
    }, [formData])

    const handleSubmit = (e) => {
        e.preventDefault()

        const validate_form = validateForm()
        if (validate_form) {
            funAddUpdate({
                data: {
                    comp_code: compCode.join(","),
                    detail_id: formData[formField.detailId],
                    year: formData[formField.year],
                    month: formData[formField.month],
                    unit_id: formData[formField.unitId],
                    ac_id: formData[formField.acId],
                    exp_type: formData[formField.expType],
                    amount: formData[formField.amount],
                    rec_status: !isNewEntry ? 1 : 2
                }
            })
        }
    }

    useEffect(() => {
        if (!isNewEntry && detailParams && Object.keys(detailParams)?.length > 0) {
            if (detail && detail?.length > 0) {
                setFormData({
                    ...formData,
                    [formField.detailId]: detail[0]?.DetailId || 0,
                    [formField.year]: detail[0]?.Year || '',
                    [formField.month]: detail[0]?.Month || '',
                    [formField.unitId]: detail[0]?.UnitId || '',
                    [formField.acId]: detail[0]?.AcId || '',
                    [formField.amount]: detail[0]?.Amount || 0,
                    [formField.expType]: detail[0]?.Exp_Type || '',

                })
            }
        }

    }, [detail])
    const handleClickPrev = () => {
        //navigate(linksUrl.monthExpense.monthExpEntryMaster)

    }

    if (isPending) {
        return <LoadingCard />;
    }
    if (isError || isErrorDetail) {
        return <ErrorCard />;
    }

    return (
        <div>
            {/* <MainContainer
                pageName={`${isNewEntry ? "New" : "Update"} Monthly Provisinal Expense Entry`}
                breadcrumbs={["", "Monthly Provisinal Expense Entry"]}
            // prevPage={{
            //     show: true,
            //     onClick: handleClickPrev,
            // }}
            > */}
            <div shadow="sm" className="mb-3 w-full">
                <form onSubmit={handleSubmit} autoComplete='off'>
                    {
                        Object.keys(inputBoxes).map((key, ind) => (
                            <div key={key + ind}>
                                <div className={` ${isMobile ? 'flex-wrap' : ''}   flex gap-4 align-top items-baseline mb-2 `}>
                                    {
                                        inputBoxes[key].map((item, indx) =>
                                            item.type == ENUM_INPUT_TYPE.select ? (
                                                <></>
                                            ) : item.type == ENUM_INPUT_TYPE.autocomplete ? (
                                                <Autocomplete
                                                    size="md"
                                                    name={item.name}
                                                    isInvalid={errors[item.name]}
                                                    errorMessage={errors[item.name]}
                                                    label={item?.placeholder}
                                                    eventResizeFeature={true}
                                                    selectionMode="single"
                                                    showScrollIndicators={true}
                                                    labelPlacement={"outside"}
                                                    placeholder={item.placeholder}
                                                    isRequired={item.isrequired}
                                                    isLoading={isLoading}
                                                    className="max-w-23"
                                                    classNames={{
                                                        label: "text-xs text-black font-bold",
                                                    }}
                                                    isClearable={false}
                                                    isVirtualized
                                                    readonly={isNewEntry ? false : true}
                                                    defaultItems={
                                                        item.data ? item.data : []
                                                    }
                                                    onSelectionChange={(e) =>
                                                        handleAutoCompleteChange(e, item.name)
                                                    }
                                                    color={item.id == formField.debitAcId ? "success" : item.id == formField.creditAcId ? "primary" : ""}
                                                    //onChange={handleFormSelectionChange}
                                                    selectedKey={formData[item.name]}
                                                >
                                                    {(list) => (
                                                        <AutocompleteItem

                                                            key={list[item.itemkey]}
                                                        >
                                                            {list[item.itemvalue]}
                                                        </AutocompleteItem>
                                                    )}
                                                </Autocomplete>

                                            ) : item.type == ENUM_INPUT_TYPE.date ? (
                                                <div className=" w-full flex items-center">
                                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                        <DatePicker
                                                            label={item.placeholder}
                                                            views={["day", "month", "year"]}
                                                            format="DD/MM/YYYY"
                                                            value={
                                                                formData[item.name]
                                                                    ? dayjs(formData[item.name])
                                                                    : formData[item.name]
                                                            }
                                                            onChange={(newValue) => {
                                                                setFormData((prev) => {
                                                                    return {
                                                                        ...prev,
                                                                        [item.name]: newValue != '' && newValue != 'Invalid Date' ?
                                                                            dayjs(newValue).format("YYYY-MM-DD") : null,
                                                                    };
                                                                });
                                                            }}
                                                            //isRequired={item.required}
                                                            className="w-full "
                                                            slotProps={{
                                                                textField: { size: "small", error: errors[item.name], helperText: errors[item.name], required: true },
                                                            }}
                                                        />
                                                    </LocalizationProvider>
                                                </div>
                                            ) : (
                                                <Input
                                                    type={item.type}
                                                    name={item.name}
                                                    id={item.name}
                                                    isInvalid={errors[item.name]}
                                                    errorMessage={errors[item.name]}
                                                    placeholder={item.placeholder}
                                                    label={item.placeholder}
                                                    labelPlacement="outside"
                                                    isRequired={item.isrequired}
                                                    value={formData[item.name]}
                                                    variant="bordered"
                                                    onChange={(e) => handleChange(e)}
                                                    onBlur={(e) => handleBlur(e)}
                                                    readOnly={item.name == formField.vouNo ? true : false}
                                                    size={"md"}
                                                    maxLength={item.name == formField.year ? 4 : 100}
                                                    classNames={{
                                                        label: "text-xs text-black font-bold",
                                                    }}
                                                ></Input>
                                            )
                                        )
                                    }
                                </div>

                            </div>

                        ))
                    }

                    <div className="justify-center flex gap-5 mt-5">
                        <Button
                            color="primary"
                            type="submit"
                            size="sm"
                            variant="shadow"
                            startContent={<FontAwesomeIcon icon={faSave} />}
                        >
                            Submit
                        </Button>
                        {/* <Button
                                color="danger"
                                variant="shadow"
                                size="md"
                                tabIndex={-1}
                                onPress={handleClickPrev}
                                startContent={<FontAwesomeIcon icon={faCancel} />}
                            >
                                Reset
                            </Button> */}
                    </div>
                </form>
            </div>
            {/* </MainContainer> */}
        </div>
    )

}
export default CreateMonthExpEntry